import { memo } from 'react'
import { SubtitleText, WinText, SubtitleContainer } from './Bounty.styled'

interface BountySubtitleProps {
  subtitle?: string
}

const BountySubtitle: React.FC<BountySubtitleProps> = ({ subtitle }) => {
  if (!subtitle) return null

  const parts = subtitle.split('win')

  return (
    <SubtitleContainer>
      <SubtitleText>{parts[0].trim()}</SubtitleText>
      {parts.length > 1 && <WinText>WIN {parts[1].trim()}</WinText>}
    </SubtitleContainer>
  )
}

export default memo(BountySubtitle)
